import { AirHandlerUnitIcon } from "@eisox/icons";

import { polymorphicForwardRef } from "~/types/polymorphic-forward-ref";

import { ExpandedItem, type ExpandedItemProps } from "./expended-item";

const ExpandedAirHandlerUnit = polymorphicForwardRef<"div", Omit<ExpandedItemProps, "icon">>(
  (
    {
      backgroundColor = "darkBlue",
      iconProps = {
        backgroundColor: "white",
        color: "darkBlue",
      },
      ...props
    },
    ref,
  ) => (
    <ExpandedItem
      {...props}
      ref={ref}
      icon={<AirHandlerUnitIcon />}
      iconProps={iconProps}
      backgroundColor={backgroundColor}
    />
  ),
);

ExpandedAirHandlerUnit.displayName = "ExpandedAirHandlerUnit";

export { ExpandedAirHandlerUnit };
